export function highlight(text = '', query = '', color?: string) {
    if (!query) {
        return text;
    }
    const pattern = new RegExp('(' + query.replaceAll(/[\s#$()*+,.?[\\\]^{|}-]/g, '\\$&') + ')', 'gi');
    const replaceWith = '<span style="color: ' + (color ?? 'var(--primary-color)') + ';">$1</span>';

    return text.replace(pattern, replaceWith);
}
